module.exports = __webpack_public_path__ + "img/BirdSilhouette.83f473b2.png";